import { parser } from './../utils/comparablesUtils';
import isNil from 'lodash/isNil';
// Types
import type { ComparablesApiType } from 'app/shared/types/ApiResponseTypes';
type PhotosType = {
    medium: string;
};

class Comparables {
    // Identification
    aliasEncoded: string | null;
    listingId: string | null;
    zpid: number | null;
    // Address
    street: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    unit: string | null;
    // Geo
    lat: number | null;
    lon: number | null;
    // Details
    propertyType: string | null;
    propertyPhotos: Array<PhotosType> | null;
    monthlyRent: string | null;
    distance: string | null;
    sqft: string | null;
    pricePerSqft: string | null;
    beds: number | null;
    baths: number | null;
    fullBaths: number | null;
    partialBaths: number | null;
    unitsAvailable: number | null;
    // Amenities
    ac: string | null;
    heating: string | null;
    laundry: string | null;
    parking: string | null;
    pets: string | null;
    // Misc
    isActive: boolean | null;
    isUsersComp: boolean;
    status: string | null;
    url: string | null;
    // Bubble window
    bubblePrice: string | null;

    constructor(res: ComparablesApiType = <ComparablesApiType>{}) {
        if (res) {
            // Identification
            this.aliasEncoded = !isNil(res.aliasEncoded) ? res.aliasEncoded : null;
            this.listingId = !isNil(res.floorplanGroupId) ? res.floorplanGroupId : null;
            this.zpid = !isNil(res.zpid) ? Number(res.zpid) : null;

            // Address
            this.street = !isNil(res.address) && !isNil(res.address.street) ? res.address.street : null;
            this.city = !isNil(res.address) && !isNil(res.address.city) ? res.address.city : null;
            this.state = !isNil(res.address) && !isNil(res.address.state) ? res.address.state : null;
            this.zip = !isNil(res.address) && !isNil(res.address.zip) ? res.address.zip : null;
            this.unit = null;

            // Geo
            this.lat = !isNil(res.geo) && !isNil(res.geo.lat) ? res.geo.lat : null;
            this.lon = !isNil(res.geo) && !isNil(res.geo.lon) ? res.geo.lon : null;

            // Details
            this.propertyType = !isNil(res.propertyType) ? res.propertyType : null;
            this.propertyPhotos =
                !isNil(res.photos) && !isNil(res.photos.listingPhotos) ? res.photos.listingPhotos : null;
            this.monthlyRent = !isNil(res.lowPrice) ? parser.monthlyRent(res.lowPrice, res.highPrice) : null;
            this.distance = !isNil(res.distanceInMiles) ? res.distanceInMiles.toFixed(1) : null;
            this.sqft = !isNil(res.minSqft) ? parser.sqft(res.minSqft, res.maxSqft) : null;
            this.pricePerSqft =
                !isNil(res.lowPrice) && !isNil(res.minSqft)
                    ? parser.pricePerSqft(res.lowPrice, res.highPrice, res.minSqft)
                    : null;
            this.beds = !isNil(res.numBeds) ? res.numBeds : null;
            this.baths = !isNil(res.numFullBaths) ? res.numFullBaths : null; // TODO remove
            this.fullBaths = !isNil(res.numFullBaths) ? res.numFullBaths : null;
            this.partialBaths = !isNil(res.numPartialBaths) ? res.numPartialBaths : null;
            this.unitsAvailable = !isNil(res.numUnitsAvailable) ? res.numUnitsAvailable : null;

            // Amenities
            this.ac =
                !isNil(res.amenities) && !isNil(res.amenities.hvac) && !isNil(res.amenities.hvac.airConditioning)
                    ? parser.ac(res.amenities.hvac.airConditioning)
                    : null;
            this.heating =
                !isNil(res.amenities) && !isNil(res.amenities.hvac) && !isNil(res.amenities.hvac.heating)
                    ? parser.heat(res.amenities.hvac.heating)
                    : null;
            this.laundry =
                !isNil(res.amenities) && !isNil(res.amenities.laundry) ? parser.laundry(res.amenities.laundry) : null;
            this.parking =
                !isNil(res.amenities) && !isNil(res.amenities.parking) ? parser.parking(res.amenities.parking) : null;
            this.pets = !isNil(res.amenities) && !isNil(res.amenities.pets) ? parser.pets(res.amenities.pets) : null;

            // Misc
            this.isActive = !isNil(res.active) ? res.active : null;
            this.isUsersComp = false;
            this.status = parser.getStatus(res.active, res.history, res.numUnitsAvailable);
            this.url = !isNil(res.propertyUrl) ? res.propertyUrl : null;

            // Map BubbleWindow
            this.bubblePrice = !isNil(res.lowPrice)
                ? parser.bubbleWindow.monthlyRent(res.lowPrice, res.highPrice)
                : null;
        } else {
            this.aliasEncoded = null;
            this.listingId = null;
            this.zpid = null;
            this.street = null;
            this.city = null;
            this.state = null;
            this.zip = null;
            this.unit = null;
            this.lat = null;
            this.lon = null;
            this.propertyType = null;
            this.propertyPhotos = null;
            this.monthlyRent = null;
            this.distance = null;
            this.sqft = null;
            this.pricePerSqft = null;
            this.beds = null;
            this.baths = null;
            this.fullBaths = null;
            this.partialBaths = null;
            this.unitsAvailable = null;
            this.ac = null;
            this.heating = null;
            this.laundry = null;
            this.parking = null;
            this.pets = null;
            this.isActive = null;
            this.isUsersComp = false;
            this.status = null;
            this.url = null;
            this.bubblePrice = null;
        }
    }
}

export default Comparables;
